import type { CalendarUpsertSchema } from '@repo/schemas/meeting/calendarUpsert';
import type { GroupPublic } from '@repo/types/groups';
import type { UserPublic } from '@repo/types/users';
import type { UseFormSetValue } from 'react-hook-form';

import { useCallback } from 'react';

interface UseParticipantSelectionProps {
  users: UserPublic[];
  groups: GroupPublic[];
  setValue: UseFormSetValue<CalendarUpsertSchema>;
}

export function useParticipantSelection(useParticipantSelectionProps: UseParticipantSelectionProps) {
  const { users, groups, setValue } = useParticipantSelectionProps;
  const handleSelectedUsersChange = useCallback(
    (newUsers: UserPublic[]) => {
      setValue('users', newUsers);
    },
    [setValue]
  );

  const handleSelectedGroupsChange = useCallback(
    (newGroups: GroupPublic[]) => {
      setValue('groups', newGroups);
    },
    [setValue]
  );

  const onRemoveUser = useCallback(
    (id: number) => {
      setValue(
        'users',
        users.filter((user) => user.id !== id)
      );
    },
    [users, setValue]
  );

  const onRemoveGroup = useCallback(
    (id: number) => {
      setValue(
        'groups',
        groups.filter((group) => group.id !== id)
      );
    },
    [groups, setValue]
  );

  return {
    handleSelectedUsersChange,
    handleSelectedGroupsChange,
    onRemoveUser,
    onRemoveGroup,
  };
}
